export default __webpack_public_path__ + "static/media/Estrategico.8f8c7052.png";